import { Action, createReducer, on } from '@ngrx/store';
import { StateBuilder } from '../../../model/state.builder';
import { OnlineUseActions } from './online-use.actions';
import { IOnlineUseState } from './online-use.state';

export const initialOnlineUseState: IOnlineUseState = {
  model: undefined,
  data: undefined,
  uiState: undefined
};

const onlineUseReducerFn = createReducer(
  initialOnlineUseState,
  on(OnlineUseActions.reset, (state: IOnlineUseState, action) => {
    return new StateBuilder<IOnlineUseState>(initialOnlineUseState).build();
  }),
  on(OnlineUseActions.load, (state: IOnlineUseState, action) => {
    return new StateBuilder<IOnlineUseState>(state).toLoading().build();
  }),
  on(OnlineUseActions.loadSuccess, (state: IOnlineUseState, action) => {
    return new StateBuilder<IOnlineUseState>(state, action).toLoaded().build();
  }),
  on(OnlineUseActions.submit, (state: IOnlineUseState, action) => {
    return new StateBuilder<IOnlineUseState>(state, action).toLoading().build();
  }),
  on(OnlineUseActions.submitSuccess, (state: IOnlineUseState, action) => {
    return new StateBuilder<IOnlineUseState>(state, action).toLoaded().build();
  })
);

export function onlineUseReducer(state: IOnlineUseState | undefined, action: Action) {
  return onlineUseReducerFn(state, action);
}
